import * as ZapparThree from '@zappar/zappar-threejs';
import { THREE } from '@zappar/zappar-threejs/lib/three';

const targets = [
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar11.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar12.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar13.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar14.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar15.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar16.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar17.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar18.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar19.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/id.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/passport0.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/passport1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/passport2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/passport3.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/passport4.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/passport5.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/cedar20.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/flag.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/flag2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/jewel1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/jewel2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/jewel3.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/note1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/note2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/note3.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/note4.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/note5.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/other1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/sports1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/sports2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/stamp1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/stamp2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/stamp3.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/symbol1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/symbol2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/symbol3.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/symbol4.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/tatoo2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/transport1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/transport2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/tree1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/tree2.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/tree3.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/tree4.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/tree5.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/texture1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/sticker1.zpt', import.meta.url).href },
    { url: new URL('https://zappar-media.s3.eu-west-1.amazonaws.com/draw1.zpt', import.meta.url).href }
];

const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

const notBtn = document.getElementById('notBtn');
const scanBtn = document.getElementById('scanBtn');
const againBtn = document.getElementById('againBtn');
const donateBtn = document.getElementById('donateBtn');

const closeBtn = document.getElementById('closeBtn');

const notView = document.getElementById('notView');
const scanView = document.getElementById('scanView');
const donateView = document.getElementById('donateView');

const donateNow = document.getElementById('donateNow');
const scanning = document.getElementById('scanning');

const canvas = document.getElementById('canvas');

const audioElement = document.querySelector("audio");

const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true
});

const scene = new THREE.Scene();
canvas.appendChild(renderer.domElement);

renderer.setSize(window.innerWidth, window.innerHeight);

window.addEventListener('resize', () => {
    renderer.setSize(window.innerWidth, window.innerHeight);
});

const camera = new ZapparThree.Camera();

ZapparThree.glContextSet(renderer.getContext());

scene.background = camera.backgroundTexture;

const manager = new ZapparThree.LoadingManager();

let found = false;

function donate() {
    // donateView.className = 'screen active';
    // audioElement.muted = false;
    // audioElement.play();

    setTimeout(() => {
        window.location.href = 'https://gpmena.secure.force.com/StripePaymentScreen';
    }, 0);
}

function addTracker(index) {
    const imageTracker = new ZapparThree.ImageTrackerLoader(manager).load(targets[index].url);

    imageTracker.onVisible.bind(() => {
        if (found) return;

        found = true;
        scanning.className = 'active found';
        setTimeout(donate, 2000);
    });

    // imageTracker.onNotVisible.bind(() => {
    //     if (found) return;
    //     scanning.className = '';
    // });
}

function loadAsset(): void {
    for (var i = 0; i < targets.length; i++) addTracker(i);
}

function render(): void {
    camera.updateFrame(renderer);

    renderer.render(scene, camera);

    requestAnimationFrame(render);
}

render();

closeBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    scanView.className = 'screen';
    scanning.className = '';
    donateNow.className = '';
});


scanBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    audioElement.muted = true;
    audioElement.play();
    if (ZapparThree.browserIncompatible()) {
        ZapparThree.browserIncompatibleUI();
    } else {
        ZapparThree.permissionRequest().then(granted => {
            if (granted) {
                camera.start();
                loadAsset();
                scanView.className = 'screen active';
                setTimeout(function () {
                    scanning.className = 'active';
                    donateNow.className = 'active';
                }, 2000);
            } else ZapparThree.permissionDeniedUI();
        });
    }
});

document.body.addEventListener('DOMNodeInserted', function (event) {
    document.body.removeChild(event.target);
});

donateBtn?.addEventListener('click', function (e) {
    e.preventDefault(); donate();
});

notBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    notView.className = 'screen active';
});

againBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    donateView.className = 'screen';
    notView.className = 'screen';
    scanning.className = 'active';
    found = false;
});


